module.exports = __webpack_public_path__ + "public/images/prizes/prize-thailand.894244a598f5ba679be67189525f9b19.webp";